import { getHostname } from "@/scripts/getHostname";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { storage } from "../../firebaseConfig";
import { endpoints } from "../../hooks/endpoints";
import {
  getAllowedCategoriesForPermission,
  getFileUrl,
  getToken,
  getUID
} from "../../hooks/utils";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { pushModal } from "../../store/slices/modalsSlice";
import Animation from "../Animation";
import GeneralMessageModal from "../Modals/GeneralMessageModal";
import Separator from "../Separator";
import Spinner from "../Spinner";
import { Button } from "../ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../ui/table";
import DynamicCategorySelector from "./DynamicCategorySelector";

const ManageStudent = () => {
  const [userData, setUserData] = useState(null);
  const [isPending, setIsPending] = useState(false);
  const [isPending2, setIsPending2] = useState(false);
  const [isPending3, setIsPending3] = useState(false);
  const [studentsList, setStudentsList] = useState(null);
  const [error, setError] = useState(null);
  const [error2, setError2] = useState(null);
  const [userNotFound, setUserNotFound] = useState(null);
  const [changeType, setChangeType] = useState(null);
  const [userChanged, setUserChanged] = useState(null);
  const [userChanged2, setUserChanged2] = useState(null);
  const [newValRef, setNewValRef] = useState(null);
  const [lessonRef, setLessonRef] = useState(null);
  const [imageLoading, setImageLoading] = useState(false);
  const [profilePic, setProfilePic] = useState(null);
  const [uploadedProfilePic, setUploadedProfilePic] = useState(null);
  const [profilePicState, setProfilePicState] = useState(null);
  const [fileProgress, setFileProgress] = useState(0);
  const studentNumberRef = useRef();
  const fatherPhone = useRef();
  const motherPhone = useRef();
  const city = useRef();
  const school = useRef();
  const { currentTeacher, portal } = useAppSelector((state) => state.store);
  const dispatch = useAppDispatch();

  const allowedCats = getAllowedCategoriesForPermission("can_manage_students");

  const portalCats = allowedCats
    ? portal?.cats?.filter((cat) => allowedCats.includes(cat.term_id))
    : portal?.cats;

  const handleUploadProfilePicFb = async (e) => {
    if (!e.target.files[0]) {
      dispatch(
        pushModal(<GeneralMessageModal msg="يجب اختيار صورة" btnMsg="حسنا" />)
      );
      return;
    }

    setImageLoading(true);

    // const chunks = e.target.value.split("\\");
    // const file = chunks[chunks.length - 1];
    // setProfilePicState(file);

    try {
      const imageRef = ref(storage, `profile_pics-${getUID()}`);
      await uploadBytes(imageRef, e.target.files[0]);
      const url = await getDownloadURL(imageRef);
      console.log(url);
      const upp = document.getElementById(
        "uploadedProfilePic"
      ) as HTMLImageElement;
      if (upp) upp.src = getFileUrl(url);
      // setUploadedProfilePic(getFileUrl(url));
    } catch (error) {
      dispatch(pushModal(<GeneralMessageModal msg="حدث خطأ" btnMsg="حسنا" />));
    } finally {
      setImageLoading(false);
    }
  };

  const updateProfileData = () => {
    console.log({ userData });
    setIsPending2(true);
    fetch(endpoints.updateProfile, {
      headers: {
        "Content-Type": "application/json",
        Authorization: getToken(),
      },
      method: "POST",
      body: JSON.stringify({
        uid: userData.studentId,
        father_phone: userData?.meta?.father_phone,
        mother_phone: userData?.meta?.mother_phone,
        city: userData?.meta?.city,
        school: userData?.meta?.school,
        group: userData?.meta?.group,
        profile_pic: uploadedProfilePic,
        portal: getHostname(),
      }),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.status !== 200) {
          setUserChanged2(res.message);
          setIsPending2(false);
        } else {
          setUserChanged2(res.message);
          setIsPending2(false);
        }
      })
      .catch((err) => {
        setUserChanged2(err.message);
        setIsPending2(false);
      });
  };

  const handleChangeStudent = (e) => {
    e.preventDefault();
    setIsPending(true);
    fetch(
      endpoints.changeStudentData +
        `?timestamp=${new Date().getTime()}&student=${
          userData.studentId
        }&change=${changeType}&value=${newValRef}&lesson=${lessonRef}&cat=${currentTeacher}&hostname=${getHostname()}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: getToken(),
        },
        method: "GET",
      }
    )
      .then((response) => response.json())
      .then((res) => {
        if (res.status !== 200) {
          setUserChanged("bad");
          setIsPending(false);
        } else {
          setUserChanged("good");
          setIsPending(false);
        }
      })
      .catch((err) => {
        setUserChanged("bad");
        setIsPending(false);
      });
  };

  const getUserAndData = (e) => {
    e.preventDefault();
    setIsPending(true);
    setUserChanged(null);
    fetch(
      endpoints.getStudentData +
        `?timestamp=${new Date().getTime()}&student=${(
          studentNumberRef.current.value as string
        ).trim()}&teacher=${currentTeacher}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: getToken(),
        },
        method: "GET",
      }
    )
      .then((response) => response.json())
      .then((res) => {
        if (res.status !== 200) {
          setUserNotFound("لا يوجد طالب بهذا الرقم");
          setIsPending(false);
        } else {
          setUserData(res);
          setUploadedProfilePic(res?.meta?.profile_pic);
          setUserNotFound(null);
          setIsPending(false);
        }
      })
      .catch((err) => {
        setUserNotFound("لا يوجد طالب بهذا الرقم");
        setIsPending(false);
        setError(err);
      });
  };

  const getStudentsList = () => {
    setIsPending3(true);
    fetch(endpoints.studentsList + `?date=${new Date().getTime()}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: getToken(),
      },
      method: "GET",
    })
      .then((res) => res.json())
      .then((data) => {
        setIsPending3(false);
        setStudentsList(data);
      })
      .catch((err) => {
        console.log(err);
        setError2("حدث خطأ");
        setIsPending3(false);
      });
  };

  function downloadJSONAsCSV(jsonData) {
    // Check if data is valid JSON
    if (!jsonData || !Array.isArray(jsonData)) {
      console.error("Invalid JSON data provided.");
      return;
    }

    // Get the headers (assuming all objects have the same keys)
    const headers = Object.keys(jsonData[0]);

    // Create the CSV content
    let csvContent = "";

    // Add the header row
    csvContent += headers.join(",") + "\n";

    // Loop through each object and create a CSV row
    jsonData.forEach(function (row) {
      const data = headers
        .map((header) => {
          // Check if value is string and contains non-ASCII characters
          if (
            typeof row[header] === "string" &&
            /[^\u0000-\u007f]/.test(row[header])
          ) {
            // Quote the value and escape quotes
            return '"' + row[header].replace(/"/g, '""') + '"';
          }
          return JSON.stringify(row[header]);
        })
        .join(",");
      csvContent += data + "\n";
    });

    // Create a Blob object with the CSV data
    const blob = new Blob(["\uFEFF", csvContent], {
      type: "text/csv;charset=utf-8",
    });

    // Create a downloadable link
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "students-list.csv";
    link.style.display = "none"; // Hide the link element

    // Append the link to the document body (for browser compatibility)
    document.body.appendChild(link);

    // Simulate a click on the link to trigger download
    link.click();

    // Remove the link from the document body
    document.body.removeChild(link);
  }

  return (
    <Animation>
      <div className="space-y-6">
        <h3 className="bg-primary p-3 text-white rounded-lg shadow font-bold">
          إدارة الطلاب
        </h3>
        <div className="p-3 bg-white rounded-lg shadow space-y-6">
          <Button onClick={getStudentsList} disabled={isPending3}>
            {isPending3 ? <Spinner variant="button" /> : "عرض جميع الطلاب"}
          </Button>
          {studentsList && (
            <>
              <div className="flex items-end gap-4">
                <p className="font-bold text-lg">
                  عدد الطلاب: {Object.keys(studentsList).length}
                </p>
                <Button
                  onClick={() => downloadJSONAsCSV(Object.values(studentsList))}
                >
                  تحميل شيت إكسل
                </Button>
              </div>
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead scope="col" className="text-start">
                      #
                    </TableHead>
                    <TableHead scope="col" className="text-start">
                      الإسم
                    </TableHead>
                    <TableHead scope="col" className="text-start">
                      تليفون
                    </TableHead>
                    {/* <TableHead scope="col" className="text-start">إيميل</TableHead> */}
                    <TableHead scope="col" className="text-start">
                      رقم الأب
                    </TableHead>
                    <TableHead scope="col" className="text-start">
                      رقم الأم
                    </TableHead>
                    <TableHead scope="col" className="text-start">
                      الحصص
                    </TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {studentsList &&
                    Object.values(studentsList).map((student, index) => (
                      <TableRow key={student.uid}>
                        <TableCell style={{ maxWidth: "15px" }} scope="row">
                          {index + 1}
                        </TableCell>
                        <TableCell style={{ maxWidth: "200px" }}>
                          {student.name}
                        </TableCell>
                        <TableCell style={{ maxWidth: "100px" }}>
                          {student.phone}
                        </TableCell>
                        {/* <TableCell>{student.email}</TableCell> */}
                        <TableCell style={{ maxWidth: "100px" }}>
                          {student.father_phone}
                        </TableCell>
                        <TableCell style={{ maxWidth: "100px" }}>
                          {student.mother_phone}
                        </TableCell>
                        <TableCell style={{ maxWidth: "100px" }}>
                          {student.purchase_count}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </>
          )}
          <form className="space-y-4" onSubmit={getUserAndData}>
            <div className="flex flex-col gap-2">
              <label htmlFor="studentNumber">رقم هاتف الطالب</label>
              <input
                ref={studentNumberRef}
                type="text"
                className="rounded-md p-2 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-(--primary-color-light) focus:border-transparent"
                id="studentNumber"
                placeholder="01XX XXXX XXX"
              />
            </div>
            <Button type="submit" disabled={isPending}>
              {isPending ? <Spinner variant="button" /> : "بحث"}
            </Button>
            {userNotFound && (
              <div
                className="my-2 rounded-lg text-red-600 bg-red-100 border border-red-400 p-3"
                style={{ width: "20%", minWidth: "200px" }}
                role="alert"
              >
                {userNotFound}
              </div>
            )}
          </form>
          {userData && userData.meta && !userNotFound && (
            <div className="m-3 space-y-4">
              <Separator />
              {userData &&
                userData.meta.disabled_sites &&
                userData.meta.disabled_sites.filter(
                  (site) => site.toString() === getHostname().toString()
                ).length > 0 && (
                  <div className="text-red-600 bg-red-100 border border-red-400 p-3 my-2 rounded-lg w-full">
                    تم منع هذا الطالب من الدخول للمنصة
                  </div>
                )}
              <div
                className={`text-center mt-10 mx-auto w-fit ${
                  imageLoading &&
                  "relative flex justify-center items-center opacity-75"
                }`}
              >
                <input
                  onChange={(e) => handleUploadProfilePicFb(e)}
                  type="file"
                  id="profilePic"
                  className="hidden"
                  hidden
                />
                <img
                  id="uploadedProfilePic"
                  onClick={() => {
                    const profilePicInput =
                      document.getElementById("profilePic");
                    profilePicInput.click();
                  }}
                  onLoad={() => setImageLoading(false)}
                  ref={profilePic}
                  src={
                    uploadedProfilePic
                      ? decodeURIComponent(uploadedProfilePic)
                      : "https://eliteacademymedia.s3.us-east-1.amazonaws.com/eliteacademymedia/placeholder-profile-image.jpg"
                  }
                  className="rounded-lg object-cover aspect-square shadow-sm border border-primary max-w-56 cursor-pointer"
                  alt="صورة شخصية"
                />
                {imageLoading && (
                  <Spinner variant="button" className="absolute size-20 z-10" />
                )}
              </div>

              <div className="flex flex-col gap-2">
                <label htmlFor="" className="text-base">
                  الإسم رباعي
                </label>
                <input
                  type="text"
                  className="p-2 rounded-md border bg-gray-200 focus:ring-(--primary-color-light) border-gray-200"
                  placeholder={userData.meta.name}
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  value={userData.meta.name}
                  contentEditable={false}
                  disabled
                />
              </div>
              <div className="flex flex-col md:flex-row gap-4">
                <div className="col-md-6 col-12 grow">
                  <div className="flex flex-col gap-2">
                    <label htmlFor="" className="text-base">
                      تليفون
                    </label>
                    <input
                      type="text"
                      className="p-2 rounded-md border bg-gray-200 focus:ring-(--primary-color-light) border-gray-200"
                      placeholder={userData.meta.phone}
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      value={userData.meta.phone}
                      contentEditable={false}
                      disabled
                    />
                  </div>
                </div>
                <div className="col-md-6 col-12 grow">
                  <div className="flex flex-col gap-2">
                    <label htmlFor="" className="text-base">
                      إيميل
                    </label>
                    <input
                      type="text"
                      className="p-2 rounded-md border focus:ring-(--primary-color-light) bg-gray-200 border-gray-200"
                      placeholder={userData.meta.email}
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      value={userData.meta.email}
                      contentEditable={false}
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div className="flex flex-col md:flex-row gap-4">
                <div className="col-md-6 col-12 grow">
                  <div className="flex flex-col gap-2">
                    <label htmlFor="" className="text-base">
                      تليفون الأب
                    </label>
                    <input
                      ref={fatherPhone}
                      value={userData.meta.father_phone}
                      onChange={(e) =>
                        setUserData({
                          ...userData,
                          meta: {
                            ...userData.meta,
                            father_phone: [e.target.value],
                          },
                        })
                      }
                      type="text"
                      className="p-2 rounded-md border border-gray-400 focus:ring-(--primary-color-light)"
                      placeholder={userData.meta.father_phone}
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      // value={userData.meta.father_phone}
                      // contentEditable={false}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-12 grow">
                  <div className="flex flex-col gap-2">
                    <label htmlFor="" className="text-base">
                      تليفون الأم
                    </label>
                    <input
                      ref={motherPhone}
                      value={userData.meta.mother_phone}
                      onChange={(e) =>
                        setUserData({
                          ...userData,
                          meta: {
                            ...userData.meta,
                            mother_phone: [e.target.value],
                          },
                        })
                      }
                      type="text"
                      className="p-2 rounded-md border border-gray-400 focus:ring-(--primary-color-light)"
                      placeholder={userData.meta.mother_phone}
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      // value={userData.meta.mother_phone}
                      // contentEditable={false}
                    />
                  </div>
                </div>
              </div>
              <div className="flex flex-col md:flex-row gap-4">
                <div className="col-md-6 col-12 grow">
                  <div className="flex flex-col gap-2">
                    <label htmlFor="" className="text-base">
                      المحافظة
                    </label>
                    <input
                      ref={city}
                      value={userData.meta.city}
                      onChange={(e) =>
                        setUserData({
                          ...userData,
                          meta: { ...userData.meta, city: e.target.value },
                        })
                      }
                      type="text"
                      className="p-2 rounded-md border border-gray-400 focus:ring-(--primary-color-light)"
                      placeholder={userData.meta.city}
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      // value={userData.meta.city}
                      // contentEditable={false}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-12 grow">
                  <div className="flex flex-col gap-2">
                    <label htmlFor="" className="text-base">
                      المدرسة
                    </label>
                    <input
                      ref={school}
                      value={userData.meta.school}
                      onChange={(e) =>
                        setUserData({
                          ...userData,
                          meta: { ...userData.meta, school: e.target.value },
                        })
                      }
                      type="text"
                      className="p-2 rounded-md border border-gray-400 focus:ring-(--primary-color-light)"
                      placeholder={userData.meta.school}
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      // value={userData.meta.school}
                      // contentEditable={false}
                    />
                  </div>
                </div>
              </div>
              {/* <div className="col-md-6 col-12">
                <div className="flex flex-col gap-2">
                  <label htmlFor="" className="text-base">
                    المجموعة
                  </label>
                  <select
                    className="form-select form-select-md"
                    aria-label=".form-select-lg example"
                    value={
                      userData?.meta?.[
                        `${getHostname()}_group`
                      ]?.[0] ?? ""
                    }
                    onChange={(e) => {
                      setUserData((prev) => ({
                        ...prev,
                        meta: {
                          ...prev.meta,
                          [`${getHostname()}_group`]: [
                            e.target.value,
                          ],
                        },
                      }));
                    }}
                    required
                  >
                    <option value="" selected>
                      إختر المجموعة
                    </option>
                    {(portal?.offline_groups?.length > 0
                      ? portal?.offline_groups
                      : ["أونلاين"]
                    ).map((group: string) => (
                      <option value={group}>{group}</option>
                    ))}
                  </select>
                </div>
              </div> */}

              <div className="flex flex-col md:flex-row gap-2">
                <Button
                  type="button"
                  onClick={updateProfileData}
                  disabled={isPending2}
                >
                  {isPending2 ? (
                    <Spinner variant="button" />
                  ) : (
                    "تعديل البيانات الأساسية"
                  )}
                </Button>
                {userChanged2 && (
                  <div
                    className={`ms-2 w-fit py-1 px-4 border ${
                      userChanged2.indexOf("تم") > -1
                        ? "bg-green-100 text-green-700 border-green-400"
                        : "bg-red-100 text-red-500 border-red-400"
                    } rounded-lg`}
                  >
                    {userChanged2}
                  </div>
                )}
              </div>

              <Separator />

              <div className="flex">
                <p className="text-primary font-bold text-lg m-auto pb-1 text-center border-b-2 border-(--primary-color-light)">
                  عمليات الشراء
                </p>
              </div>
              {userData.invoices && (
                <Table className="table table-striped">
                  <TableHeader>
                    <TableRow>
                      <TableHead className="text-start font-bold">
                        رقم العملية
                      </TableHead>
                      <TableHead className="text-start font-bold">
                        التاريخ
                      </TableHead>
                      <TableHead className="text-start font-bold">
                        الحالة
                      </TableHead>
                      <TableHead className="text-start font-bold">
                        الإجمالي
                      </TableHead>
                      <TableHead className="text-start font-bold">
                        تفاصيل
                      </TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {userData.invoices &&
                      userData.invoices.map((invoice, index) => (
                        <TableRow>
                          <TableCell scope="row">{invoice.id}</TableCell>
                          <TableCell>{invoice.date}</TableCell>
                          <TableCell>
                            {invoice.status === "completed" ? (
                              <p className="w-fit text-green-700 bg-green-50 border border-green-400 rounded-lg font-bold text-xs px-2 py-1">
                                تم الدفع
                              </p>
                            ) : invoice.status === "pending" ? (
                              <p className="w-fit text-yellow-700 bg-yellow-50 border border-yellow-400 rounded-lg font-bold text-xs px-2 py-1">
                                منتظر الدفع
                              </p>
                            ) : (
                              invoice.status
                            )}
                          </TableCell>
                          <TableCell>{invoice.total} جنيه</TableCell>
                          <TableCell>
                            <Link
                              to={`/purchases/${invoice.id}`}
                              style={{ maxHeight: "30px", padding: "3px 8px" }}
                              className="rounded-lg bg-primary text-white p-1 text-xs"
                            >
                              تفاصيل
                            </Link>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              )}

              <Separator />

              <div className="flex">
                <p className="text-primary font-bold text-lg m-auto pb-1 text-center border-b-2 border-(--primary-color-light)">
                  الإمتحانات
                </p>
              </div>
              {userData.grades && (
                <Table className="table table-striped">
                  <TableHeader>
                    <TableRow>
                      <TableHead className="text-start font-bold">
                        الحصة
                      </TableHead>
                      <TableHead className="text-start font-bold">
                        الدرجة
                      </TableHead>
                      <TableHead className="text-start font-bold">
                        التاريخ
                      </TableHead>
                      <TableHead className="text-start font-bold">
                        تفاصيل
                      </TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {userData.grades &&
                      userData.grades.map((grade, index) => {
                        const grade_data = JSON.parse(grade.raw_data);
                        const success =
                          grade_data.score >= (grade_data?.pass_grade ?? 0);
                        return (
                          <TableRow>
                            <TableCell>{grade.lesson_name}</TableCell>
                            <TableCell>
                              <span
                                className={
                                  success
                                    ? "text-green-600 font-bold"
                                    : "text-red-600 font-bold"
                                }
                              >
                                {grade.raw_data !== "" &&
                                  `${grade_data.maxScore} / ${grade_data.score}`}
                              </span>
                            </TableCell>
                            <TableCell>{grade.date}</TableCell>
                            <TableCell>
                              {grade.raw_data && (
                                <Link
                                  to={`/grades/${grade.id}`}
                                  style={{
                                    maxHeight: "30px",
                                    padding: "3px 8px",
                                  }}
                                  className="rounded-lg bg-primary text-white p-1 text-xs"
                                >
                                  تفاصيل
                                </Link>
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              )}

              <Separator />

              <div className="flex">
                <p className="text-primary font-bold text-lg m-auto pb-1 mb-2 text-center border-b-2 border-(--primary-color-light)">
                  تغبير البيانات
                </p>
              </div>

              <form
                onSubmit={handleChangeStudent}
                className="flex flex-col gap-4"
              >
                <select
                  value={changeType}
                  onChange={(e) => setChangeType(e.target.value)}
                  className="px-2 py-1 rounded-lg border border-gray-400 w-full md:w-1/2 focus:ring-(--primary-color-light)"
                >
                  <option selected>تغببر البيانات</option>
                  <option value="addView">إضافة مشاهدة</option>
                  <option value="remView">خصم مشاهدة</option>
                  <option value="addTime">إضافة ساعات لوقت مشاهدة الحصة</option>
                  <option value="remTime">خصم ساعات من وقت مشاهدة الحصة</option>
                  <option value="passQuiz">تخطي إمتحان</option>
                  <option value="passLesson">تخطي حصة</option>
                  <option value="disableStudent">
                    منع هذا الطالب من الدخول للمنصة
                  </option>
                  <option value="enableStudent">
                    السماح للطالب بالدخول للمنصة
                  </option>
                </select>
                {(changeType === "addView" ||
                  changeType === "remView" ||
                  changeType === "addTime" ||
                  changeType === "remTime") && (
                  <div className="flex flex-col gap-2">
                    {/* <label htmlFor="newValRef">العدد</label> */}
                    <input
                      onChange={(e) => setNewValRef(e.target.value)}
                      value={newValRef}
                      type="number"
                      className="px-2 py-1 rounded-lg border border-gray-400 w-full md:w-1/2 focus:ring-(--primary-color-light)"
                      id="newValRef"
                      placeholder="العدد"
                    />
                  </div>
                )}
                {changeType &&
                  changeType !== "disableStudent" &&
                  changeType !== "enableStudent" && (
                    // <select
                    //   onChange={(e) => setLessonRef(e.target.value)}
                    //   value={lessonRef}
                    //   className="px-2 py-1 rounded-lg border border-gray-400 w-full md:w-1/2 focus:ring-(--primary-color-light)"
                    // >
                    //   <option selected>إختر الحصة</option>
                    //   {portal.data
                    //     .filter(
                    //       (lesson) =>
                    //         !!portalCats?.find(
                    //           (cat) => cat.term_id == lesson.term_taxonomy_id
                    //         )
                    //     )
                    //     .map((lesson) => (
                    //       <option value={lesson.ID}>
                    //         {convertText(lesson.post_title)}
                    //       </option>
                    //     ))}
                    // </select>
                    <DynamicCategorySelector
                      filteredCats={portalCats}
                      showLessonsSelector={true}
                      excludeCatsThatHasLessons={false}
                      lessonUpdateHanlderFunction={setLessonRef}
                    />
                  )}
                <Button type="submit" className="md:w-fit w-full">
                  {isPending ? <Spinner variant="button" /> : "تغبير البيانات"}
                </Button>
                {userChanged && (
                  <div
                    className={`w-fit py-1 px-4 border ${
                      userChanged === "good"
                        ? "bg-green-100 text-green-700 border-green-400"
                        : "bg-red-100 text-red-500 border-red-400"
                    } rounded-lg`}
                    style={{ width: "20%", minWidth: "200px" }}
                  >
                    {userChanged === "good"
                      ? "تم تغيير البيانات بنجاح"
                      : "حدث خطأ"}
                  </div>
                )}
              </form>
            </div>
          )}
          {error && !userNotFound /** && <h2>يجب تسجيل الدخول اولا</h2> */}
        </div>
      </div>
    </Animation>
  );
};

export default ManageStudent;
